import { IProjectDiscussion } from '@discussion/projectDiscussion/projectDiscussion.models';
import { EProjectDiscussionFileType } from '@discussion/projectDiscussion/projectDiscussionFile/projectDiscussionFile.constants';
import { EProjectFileType } from '@file/projectFile/projectFile.constants';
import { convertISOStringToLocalDateString, Grid } from '@gcl/react-core';
import * as React from 'react';
import { DiscussionRowLayout } from './DiscussionRowLayout';
import './IssuedDiscussionRow.scss';

interface IIssuedDiscussionRowProps {
  bottomComponent?: React.ReactElement;
  discussion: IProjectDiscussion;
  isReply?: boolean;
  fileFormType: EProjectFileType;
  discussionFileType: EProjectDiscussionFileType;
}

export const IssuedDiscussionRow = ({
  bottomComponent = undefined,
  discussion,
  isReply = false,
  fileFormType,
  discussionFileType,
}: IIssuedDiscussionRowProps) => {
  const author = React.useMemo(() => {
    return isReply ? discussion.repliedBy : discussion.commentedBy;
  }, [isReply, JSON.stringify(discussion)]);
  const revision = React.useMemo(() => {
    return isReply ? discussion.responseRevision : discussion.commentRevision;
  }, [isReply, JSON.stringify(discussion)]);
  const date = React.useMemo(() => {
    return isReply ? discussion.repliedDate : discussion.discussionDate;
  }, [isReply, JSON.stringify(discussion)]);

  return (
    <DiscussionRowLayout
      discussionId={discussion.id}
      contentComponent={
        <Grid container className="gcl-mb-sm">
          <Grid item xs={12}>
            {author?.displayName || ''}
            <span className="gcl-ml-sm gcl-gems-issued-discussion-row-date">
              {date ? convertISOStringToLocalDateString(date) : ''}
            </span>
            {revision && revision > 0 ? <span className="gcl-ml-sm">{revision}</span> : undefined}
          </Grid>
          <Grid item xs={12}>
            {isReply ? discussion.furtherAction : discussion.comment}
          </Grid>
        </Grid>
      }
      isReply={isReply}
      authorName={author?.displayName || ''}
      authorUid={author?.uid}
      files={(isReply ? discussion?.responseAttachments : discussion?.commentAttachments) || []}
      isDraft={false}
      isSelected={false}
      bottomComponent={bottomComponent}
      fileFormType={fileFormType}
      discussionFileType={discussionFileType}
    />
  );
};
